import axios from 'axios';
import { User } from "../../types";

export interface LoginResponse {
    user: User;
    accessToken: string;
    refreshToken: string;
  }
  
  export async function login(username: string, password: string): Promise<LoginResponse> {
    let response: Response;
    try {
      response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });
    } catch (networkError) {
      throw new Error("Unable to reach the server. Please check your connection and try again.");
    }

    if (!response.ok) {
      // Only 400/401 mean the credentials were actually rejected; anything else
      // is a server-side problem and must not be reported as bad credentials.
      if (response.status === 400 || response.status === 401) {
        throw new Error("Invalid email or password.");
      }
      throw new Error(`Sign-in failed due to a server error (${response.status}). Please try again shortly.`);
    }

    return response.json();
  }
  
  // Forgot Password function
export async function forgotPassword(email: string): Promise<void> {
  const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/forgot-password`, {
    email ,
  });

  if (response.status !== 201) {
    throw new Error("Forgot password failed");
  }
}

export async function resetPassword(password: string, token: string): Promise<void> {
  try {
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/reset-password`, {
      password,
      token
    });
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || 'Failed to reset password.'
    );
  }
}

// Token refresh lives in the axios response interceptor (services/api.ts).
// The periodic refresher that used to live here raced with the interceptor
// against the backend's refresh-token rotation and caused forced logouts.